import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ClientHomePage from '../../features/client-portal/ClientHomePage';
import ClientActivityPage from '../../features/client-portal/ClientActivityPage';
import ClientBillingPage from '../../features/client-portal/ClientBillingPage';
import ClientSupportPage from '../../features/client-portal/ClientSupportPage';

function ClientRoutes() {
  return (
    <Routes>
      <Route element={<ClientHomePage />} index />
      <Route element={<ClientHomePage />} path="home" />
      <Route element={<ClientActivityPage />} path="activity" />
      <Route element={<ClientBillingPage />} path="billing" />
      <Route element={<ClientSupportPage />} path="support" />
      <Route element={<Navigate replace to="/client/home" />} path="*" />
    </Routes>
  );
}

export default ClientRoutes;
